import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SmartImage from 'dpl/components/SmartImage';
import Icon from 'dpl/common/components/Icon';

import breederBadgeImg from 'dpl/assets/breeder_badge.svg';

export default function MobileSoftwareSectionV3({
  softwareItems,
  isOnFirstRotatingContentStep,
  isOnLastRotatingContentStep,
  nextRotatingContent,
  prevRotatingContent,
  setRef,
  shownRotatingContentIdx
}) {
  return (
    <div className="BreederJoinMobileSoftwareSection" ref={setRef}>
      <ul className="BreederJoinMobileSoftwareSection__images flex align-items-center mb8">
        {softwareItems.map((item, idx) => (
          <li
            className={classnames(
              'BreederJoinMobileSoftwareSection__image transition tc',
              {
                'o-0': idx !== shownRotatingContentIdx
              }
            )}
            style={{
              transform: `translateX(${shownRotatingContentIdx * -100}%)`
            }}
            key={idx}
          >
            {item.photographs[0] && (
              <div className="dib relative mb5">
                <SmartImage
                  height="400px"
                  lazy={shownRotatingContentIdx === 0}
                  src={item.photographs[0].url}
                  width="209px"
                />
                <div className="absolute left-0 z-1 BreederJoinMobileSoftwareSection__badge">
                  <SmartImage
                    lazy
                    alt="Good Breeder Badge"
                    forceOriginalSrc
                    src={breederBadgeImg}
                    width="81px"
                    height="81px"
                    className="mw-100"
                  />
                </div>
              </div>
            )}
            <p
              className="mb2 subheader tl tc-m tc-l"
              /* eslint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
            <p
              className="fw-normal tl tc-m tc-l"
              /* eslint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{ __html: item.long_description }}
            />
          </li>
        ))}
      </ul>
      <div className="flex align-items-center justify-center bt bw1 b--light-gray pt4 mb5">
        <button
          className="o-50"
          disabled={isOnFirstRotatingContentStep}
          onClick={prevRotatingContent}
          type="button"
        >
          <Icon name="fat-arrow-left" />
        </button>
        <span className="ph3 f2 o-50">
          {shownRotatingContentIdx + 1} / {softwareItems.length}
        </span>
        <button
          className="o-50"
          disabled={isOnLastRotatingContentStep}
          onClick={nextRotatingContent}
          type="button"
        >
          <Icon name="fat-arrow-right" />
        </button>
      </div>
    </div>
  );
}

MobileSoftwareSectionV3.propTypes = {
  softwareItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      long_description: PropTypes.string.isRequired,
      photographs: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  isOnFirstRotatingContentStep: PropTypes.bool.isRequired,
  isOnLastRotatingContentStep: PropTypes.bool.isRequired,
  nextRotatingContent: PropTypes.func.isRequired,
  prevRotatingContent: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  setRef: PropTypes.object.isRequired,
  shownRotatingContentIdx: PropTypes.number
};

MobileSoftwareSectionV3.defaultProps = {
  shownRotatingContentIdx: null
};
